import React from "react";
import "./banner.css"

export default function Banner(){
 return (
    <img
      src="/imgs/bannermaca.png"
      alt="Banner"
      className="banner-full"
    />

  );
}